import { render, staticRenderFns } from "./purchaseCredits.vue?vue&type=template&id=7673e952"
import script from "./purchaseCredits.vue?vue&type=script&lang=js"
export * from "./purchaseCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports